import {
    chakra,
    Button
} from '@chakra-ui/react';

export const ButtonUI = chakra(Button, {
    baseStyle: {
        h: '32px',
        borderRadius: '16px',
        outline: 'none',
        border: 'none',
        minW: '60px',
        fontSize: '16px',
        cursor: 'pointer'
    }
});
